import clsx from 'clsx';
import React, { useCallback, useRef } from 'react';
import { useSelector } from 'react-redux';

import Button from '@/src/components/common/Elements/Button/Button';
import Icon, { ICONS } from '@/src/components/common/Elements/Icon/Icon';
import { Authorization, INTERNAL_USER_ROLES } from '@/src/lib/authorization/authorization';
import { RootState } from '@/src/reducers/types';

import {
  TRANSACTION_TAB_INDEX,
  useFileEntryViewer,
} from '../../../../../../store/fileEntryViewer.store';
import { BaseFormOption } from '../../../components/TreatmentForm/BaseForm/BaseForm';
import { useTreatments } from '../../../store/treatments.store';

type CreateTreatment = {
  id?: string;
  isTreatmentHidden: boolean;
};

const FORM_TYPES = {
  Base: BaseFormOption,
};

const CreateTreatment = ({
  id = '',
  isTreatmentHidden = false,
  ...otherProps
}: CreateTreatment) => {
  const buttonRef = useRef(null);
  const { setForm } = useTreatments();
  const { setActiveTab } = useFileEntryViewer();

  const loggedUser = useSelector((store: RootState) => store.loggedUser);

  const handleClick = useCallback(() => {
    const form = FORM_TYPES.Base;

    setForm(form);
    setActiveTab(TRANSACTION_TAB_INDEX);
    // toggleShowOptions(false);
  }, [setActiveTab, setForm]);

  return (
    <div className={clsx('tw-flex tw-items-center')}>
      {/* // (!) is not removed here as it is to override the styles from vendor.css */}
      <h2 className={clsx('!tw-text-[18px] tw-text-cfo-black tw-font-brandonTextMedium')}>
        Expense
      </h2>
      {!isTreatmentHidden && (
        <Authorization loggedUser={loggedUser} allowedRoles={INTERNAL_USER_ROLES}>
          <Button
            id={id}
            className={clsx(
              'tw-group',
              'tw-mr-0 tw-ml-[10px]',
              'hover:tw-bg-cfo-blue-600 hover:tw-text-white'
            )}
            buttonClassSettings={{
              variant: 'primary_light_blue',
              size: 'sm',
              weight: 'bold',
              position: 'center',
            }}
            buttonRef={buttonRef}
            onClick={handleClick}
            {...otherProps}
          >
            <Icon icon={ICONS.add} className={clsx('tw-text-[14px]')} /> Create
          </Button>
        </Authorization>
      )}
    </div>
  );
};

export default CreateTreatment;
